module.exports = "https://static.energy5.com/_next/static/images/software-b6eabe71be9b364844144a9251ff377e.png";